import script from "./textItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./textItem.vue?vue&type=script&setup=true&lang=ts"

import "./textItem.vue?vue&type=style&index=0&id=638e70af&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-638e70af"]])

export default __exports__